import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import Pill from "./pill";

export default function Data({ value, onChange, params, sources }) {
  const [_value, setValue] = useState({});

  useEffect(() => {
    if (value && value[0]) {
      setValue(value[0]);
    } else {
      setValue({});
    }
  }, [value]);

  return (
    <div className={styles.data}>
      <Pill
        value={_value}
        type={params.type}
        list={params.list}
        sources={sources}
        onDelete={() => onChange(undefined)}
        onChange={(v) => onChange([v])}
      />
    </div>
  );
}
